import { render, staticRenderFns } from "./tenModuleInfo__form.vue?vue&type=template&id=6d3be32e&scoped=true"
import script from "./tenModuleInfo__form.vue?vue&type=script&lang=js"
export * from "./tenModuleInfo__form.vue?vue&type=script&lang=js"
import style0 from "./tenModuleInfo__form.vue?vue&type=style&index=0&id=6d3be32e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3be32e",
  null
  
)

export default component.exports